import React, { useState, useEffect, useCallback } from 'react';

const API_BASE_URL = "https://final-project-5ar7.onrender.com";

export default function UpiSettings() {
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ 
  label: '', merchantName: '', upiId: '', note: '', 
  isActive: false, allowAllUsers: true,
  showAmount: false, amountUSD: '', amountINR: '', 
  amountDisplay: 'none', amountNote: '' 
});
  const [editId, setEditId] = useState(null);
  const [qrFile, setQrFile] = useState({});
  const [saving, setSaving] = useState(false);
  const [uploadingQr, setUploadingQr] = useState({});

  const fetchGateways = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/public/upi-gateways`);
      const data = await res.json();
      if (data.success) setGateways(data.gateways);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, []);

  useEffect(() => { fetchGateways(); }, [fetchGateways]);

  const handleSave = async () => {
    if (!form.label || !form.merchantName || !form.upiId) return alert('Fill all required fields');
    setSaving(true);
    try {
      const url = editId ? `${API_BASE_URL}/api/admin/public/upi-gateways/${editId}` : `${API_BASE_URL}/api/admin/public/upi-gateways`;
      const method = editId ? 'PUT' : 'POST';
      const res = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
      const data = await res.json();
      if (data.success) {
        setForm({ label: '', merchantName: '', upiId: '', note: '', isActive: false, allowAllUsers: true, showAmount: false, amountUSD: '', amountINR: '', amountDisplay: 'none', amountNote: '' });
        setEditId(null);
        fetchGateways();
      }
    } catch (e) { alert('Error saving'); }
    setSaving(false);
  };

  const handleUploadQr = async (id) => {
    const file = qrFile[id];
    if (!file) return alert('Select a QR image first');
    setUploadingQr(prev => ({ ...prev, [id]: true }));
    const fd = new FormData();
    fd.append('qrCode', file);
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/public/upi-gateways/${id}/upload-qr`, { method: 'POST', body: fd });
      const data = await res.json();
      if (data.success) fetchGateways();
      else alert('Upload failed: ' + data.message);
    } catch (e) { alert('Upload error'); }
    setUploadingQr(prev => ({ ...prev, [id]: false }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this UPI gateway?')) return;
    await fetch(`${API_BASE_URL}/api/admin/public/upi-gateways/${id}`, { method: 'DELETE' });
    fetchGateways();
  };

  const handleToggle = async (gw) => {
    await fetch(`${API_BASE_URL}/api/admin/public/upi-gateways/${gw._id}`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...gw, isActive: !gw.isActive })
    });
    fetchGateways();
  };

  const card = { background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: '1px solid #e5e7eb' };

  return (
    <div style={{ padding: 32, maxWidth: 860, margin: '0 auto' }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>🏦 UPI Gateway Settings</h1>
      <p style={{ color: '#6b7280', marginBottom: 32 }}>Manage Indian UPI payment methods shown to users during deposits.</p>

      {/* ADD / EDIT FORM */}
      <div style={card}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>{editId ? '✏️ Edit Gateway' : '➕ Add New UPI Gateway'}</h2>
       {/* Row 1: Basic info */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[['Label', 'label', 'e.g. ICICI Business UPI'], ['Merchant Name', 'merchantName', 'e.g. Tradex Securities Pvt Ltd'], ['UPI ID', 'upiId', 'e.g. tradex.123456@icici'], ['Note for User (optional)', 'note', 'e.g. Use this for INR deposits only']].map(([label, key, ph]) => (
            <div key={key}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                {label}{!key.includes('note') && <span style={{ color: 'red' }}> *</span>}
              </label>
              <input value={form[key]} onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))} placeholder={ph}
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
          ))}
        </div>

        {/* Row 2: Amount Configuration */}
        <div style={{ marginTop: 20, padding: '18px 20px', background: '#f0fdf4', borderRadius: 10, border: '1px solid #bbf7d0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: '#166534' }}>💰 Amount Configuration</span>
            <span style={{ fontSize: 12, color: '#6b7280' }}>— Set deposit amounts shown to user</span>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 14 }}>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Amount (USD) <span style={{ color: '#9ca3af', fontWeight: 400 }}>optional</span></label>
              <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #d1d5db', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
                <span style={{ padding: '10px 10px', background: '#f3f4f6', color: '#374151', fontWeight: 700, fontSize: 14, borderRight: '1px solid #d1d5db' }}>$</span>
                <input type="number" value={form.amountUSD} onChange={e => setForm(p => ({ ...p, amountUSD: e.target.value }))} placeholder="e.g. 100"
                  style={{ flex: 1, padding: '10px 12px', border: 'none', outline: 'none', fontSize: 14 }} />
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Amount (INR) <span style={{ color: '#9ca3af', fontWeight: 400 }}>optional</span></label>
              <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #d1d5db', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
                <span style={{ padding: '10px 10px', background: '#f3f4f6', color: '#374151', fontWeight: 700, fontSize: 14, borderRight: '1px solid #d1d5db' }}>₹</span>
                <input type="number" value={form.amountINR} onChange={e => setForm(p => ({ ...p, amountINR: e.target.value }))} placeholder="e.g. 8300"
                  style={{ flex: 1, padding: '10px 12px', border: 'none', outline: 'none', fontSize: 14 }} />
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Show Amount As</label>
              <select value={form.amountDisplay} onChange={e => setForm(p => ({ ...p, amountDisplay: e.target.value }))}
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, background: '#fff' }}>
                <option value="none">Don't show amount</option>
                <option value="usd_only">USD only ($)</option>
                <option value="inr_only">INR only (₹)</option>
                <option value="both">Show both USD + INR</option>
              </select>
            </div>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Amount Note <span style={{ color: '#9ca3af', fontWeight: 400 }}>optional — e.g. "Min ₹5,000 · Max ₹1,00,000"</span></label>
            <input value={form.amountNote} onChange={e => setForm(p => ({ ...p, amountNote: e.target.value }))} placeholder="e.g. Min deposit ₹5,000 · Exchange rate may vary"
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', background: '#fff' }} />
          </div>
        </div>

        {/* Row 3: Toggles */}
        <div style={{ display: 'flex', gap: 24, marginTop: 4 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={form.isActive} onChange={e => setForm(p => ({ ...p, isActive: e.target.checked }))} />
            Active (visible to users)
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={form.allowAllUsers} onChange={e => setForm(p => ({ ...p, allowAllUsers: e.target.checked }))} />
            Show to all approved users
          </label>
        </div>
        {/* QR Upload inside the form (only when editing existing) */}
        {editId && (
          <div style={{ marginTop: 4, padding: '14px 16px', background: '#eff6ff', borderRadius: 10, border: '1px solid #bfdbfe' }}>
            <p style={{ margin: '0 0 10px', fontWeight: 600, fontSize: 14, color: '#1e40af' }}>📷 Upload / Replace QR Code</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <input type="file" accept="image/*" onChange={e => setQrFile(prev => ({ ...prev, [editId]: e.target.files[0] }))} style={{ fontSize: 13 }} />
              <button onClick={() => handleUploadQr(editId)} disabled={uploadingQr[editId]}
                style={{ background: '#3b82f6', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: 7, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
                {uploadingQr[editId] ? '⏳ Uploading...' : '⬆ Upload QR'}
              </button>
              {gateways.find(g => g._id === editId)?.qrCodeUrl && (
                <img src={gateways.find(g => g._id === editId).qrCodeUrl} alt="Current QR"
                  style={{ width: 60, height: 60, borderRadius: 6, border: '2px solid #3b82f6', objectFit: 'cover' }} />
              )}
            </div>
            <p style={{ margin: '8px 0 0', color: '#6b7280', fontSize: 12 }}>💡 First save the gateway, then you can upload a QR code here or in the card below.</p>
          </div>
        )}
        {!editId && (
          <div style={{ padding: '12px 16px', background: '#f9fafb', borderRadius: 10, border: '1px dashed #d1d5db', marginTop: 4 }}>
            <p style={{ margin: 0, color: '#6b7280', fontSize: 13 }}>📷 <strong>QR Code:</strong> Click <strong>"Add Gateway"</strong> first, then upload the QR image from the card that appears below.</p>
          </div>
        )}
        <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
          <button onClick={handleSave} disabled={saving}
            style={{ background: '#10b981', color: '#fff', border: 'none', padding: '11px 28px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', fontSize: 15 }}>
            {saving ? 'Saving...' : editId ? 'Update Gateway' : 'Add Gateway'}
          </button>
          {editId && <button onClick={() => { setEditId(null); setForm({ label: '', merchantName: '', upiId: '', note: '', isActive: false, allowAllUsers: true }); }}
            style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', padding: '11px 24px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
            Cancel
          </button>}
        </div>
      </div>

      {/* EXISTING GATEWAYS */}
      {loading ? <p>Loading...</p> : gateways.length === 0 ? (
        <div style={{ ...card, textAlign: 'center', color: '#9ca3af', padding: 48 }}>
          <p style={{ fontSize: 18 }}>No UPI gateways configured yet.</p>
          <p>Add one above to get started.</p>
        </div>
      ) : gateways.map(gw => (
        <div key={gw._id} style={{ ...card, borderLeft: `4px solid ${gw.isActive ? '#10b981' : '#e5e7eb'}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>{gw.label}</h3>
                <span style={{ background: gw.isActive ? '#d1fae5' : '#f3f4f6', color: gw.isActive ? '#065f46' : '#6b7280', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
                  {gw.isActive ? '● Active' : '○ Inactive'}
                </span>
              </div>
              <p style={{ margin: '0 0 4px', color: '#374151', fontSize: 14 }}>🏢 {gw.merchantName}</p>
              <p style={{ margin: '0 0 4px', color: '#374151', fontSize: 14 }}>📱 <code style={{ background: '#f3f4f6', padding: '2px 8px', borderRadius: 4 }}>{gw.upiId}</code></p>
              {gw.note && <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 13 }}>📝 {gw.note}</p>}
              
              {/* Amount badges */}
              {(gw.amountDisplay && gw.amountDisplay !== 'none') && (
                <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                  {(gw.amountDisplay === 'usd_only' || gw.amountDisplay === 'both') && gw.amountUSD && (
                    <span style={{ background: '#dbeafe', color: '#1e40af', padding: '3px 12px', borderRadius: 20, fontSize: 13, fontWeight: 700 }}>
                      $ {Number(gw.amountUSD).toLocaleString()} USD
                    </span>
                  )}
                  {(gw.amountDisplay === 'inr_only' || gw.amountDisplay === 'both') && gw.amountINR && (
                    <span style={{ background: '#fef3c7', color: '#92400e', padding: '3px 12px', borderRadius: 20, fontSize: 13, fontWeight: 700 }}>
                      ₹ {Number(gw.amountINR).toLocaleString()} INR
                    </span>
                  )}
                  {gw.amountNote && (
                    <span style={{ color: '#6b7280', fontSize: 12 }}>— {gw.amountNote}</span>
                  )}
                </div>
              )}
              
              <p style={{ margin: '4px 0 0', color: gw.allowAllUsers ? '#10b981' : '#f59e0b', fontSize: 12, fontWeight: 600 }}>
                {gw.allowAllUsers ? '👥 Visible to all approved users' : `🔒 Restricted to ${gw.allowedUsers?.length || 0} specific users`}
              </p>
            </div>
            {gw.qrCodeUrl && (
              <img src={gw.qrCodeUrl} alt="QR" style={{ width: 90, height: 90, borderRadius: 8, border: '2px solid #e5e7eb', objectFit: 'cover', marginLeft: 20 }} />
            )}
          </div>

          {/* QR Upload */}
          <div style={{ marginTop: 16, padding: '12px 16px', background: '#f9fafb', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>📷 {gw.qrCodeUrl ? 'Replace QR Code:' : 'Upload QR Code:'}</span>
            <input type="file" accept="image/*" onChange={e => setQrFile(prev => ({ ...prev, [gw._id]: e.target.files[0] }))}
              style={{ fontSize: 13 }} />
            <button onClick={() => handleUploadQr(gw._id)} disabled={uploadingQr[gw._id]}
              style={{ background: '#3b82f6', color: '#fff', border: 'none', padding: '7px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
              {uploadingQr[gw._id] ? 'Uploading...' : '⬆ Upload'}
            </button>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
            <button onClick={() => handleToggle(gw)}
              style={{ background: gw.isActive ? '#fef3c7' : '#d1fae5', color: gw.isActive ? '#92400e' : '#065f46', border: 'none', padding: '8px 18px', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
              {gw.isActive ? '⏸ Deactivate' : '▶ Activate'}
            </button>
            <button onClick={() => { setEditId(gw._id); setForm({ label: gw.label, merchantName: gw.merchantName, upiId: gw.upiId, note: gw.note || '', isActive: gw.isActive, allowAllUsers: gw.allowAllUsers, showAmount: gw.showAmount || false, amountUSD: gw.amountUSD || '', amountINR: gw.amountINR || '', amountDisplay: gw.amountDisplay || 'none', amountNote: gw.amountNote || '' }); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              style={{ background: '#eff6ff', color: '#1d4ed8', border: 'none', padding: '8px 18px', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
              ✏️ Edit Details
            </button>
            <button onClick={() => handleDelete(gw._id)}
              style={{ background: '#fef2f2', color: '#dc2626', border: 'none', padding: '8px 18px', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
              🗑 Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}